import React from 'react';
import { motion } from 'framer-motion';

const skillsDataLeft = [
  { name: 'JavaScript' },
  { name: 'TypeScript' },
  { name: 'Node.js' },
  { name: 'React' },
  { name: 'Next.js' },
];

const skillsDataRight = [
  { name: 'Express.js' },
  { name: 'Tailwind CSS' },
  { name: 'MongoDB' },
  { name: 'PostgreSQL' },
  { name: 'System Design' },
];

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col gap-10"
    >
      <div className="py-12 font-titleFont flex flex-col gap-4 text-center">
        <p className="text-sm text-designColor tracking-[4px] uppercase">Features</p>
        <h2 className="text-3xl md:text-4xl font-bold">Development Skills</h2>
      </div>

      <div className="flex flex-col lgl:flex-row gap-10 lgl:gap-20">
        <div className="w-full lgl:w-1/2 flex flex-col gap-4">
          {skillsDataLeft.map((skill, index) => (
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              key={skill.name}
              className="w-full h-14 bg-[#1e2024] rounded-lg flex items-center px-6 border border-gray-800 shadow-shadowOne group hover:border-designColor transition-colors duration-300 cursor-pointer hover:shadow-neon"
            >
              <p className="text-lg uppercase font-medium text-gray-400 group-hover:text-designColor transition-colors duration-300 tracking-wide">
                {skill.name}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="w-full lgl:w-1/2 flex flex-col gap-4">
          {skillsDataRight.map((skill, index) => (
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              key={skill.name}
              className="w-full h-14 bg-[#1e2024] rounded-lg flex items-center px-6 border border-gray-800 shadow-shadowOne group hover:border-designColor transition-colors duration-300 cursor-pointer hover:shadow-neon"
            >
              <p className="text-lg uppercase font-medium text-gray-400 group-hover:text-designColor transition-colors duration-300 tracking-wide">
                {skill.name}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Skills;
